var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.846 12.375l-4.849 2.549.926-5.399L0 5.701l5.422-.788L7.846 0l2.425 4.913 5.421.788-3.923 3.824.926 5.399-4.849-2.549z",
    fill: "#009ee0"
  })));
}

export default SvgStarinline;